export default class NumberCounter {
    constructor(block) {
        this.figures = block.querySelectorAll('.statistic .t--stat');

        const handleIntersect = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!entry.target.dataset.counting) {
                        this.init(entry.target)
                    }

                    entry.target.dataset.counting = "true"
                }
            });
        };
        
        const observer = new IntersectionObserver(handleIntersect, {
            root: null,
            rootMargin: '-200px 0px 0px 0px',
            threshold: 0,
        });
          

        observer.observe(block);
    }

	init() {
		for (let i = 0; i < this.figures.length; i++) {
            // Assign initial animation delay
            let delay = 1000;
            let delayMilliseconds = 500;
            // Get the number columns with the box
            let numberCols = this.figures[i].getElementsByClassName('number-column');
            // Set up an array of numbers 0 through 9
            const numbers = Array(10).fill(0).map((n, i) => n + i);

            for (let c = 0; c < numberCols.length; c++) {
               for (let n = 0; n < numbers.length; n++) {
                  // Print out numbers 0 through 9 within each number column
                  numberCols[c].innerHTML += '<span class="number">'+numbers[n]+'</span>';
               }

               // Get the value of each number column and alter -em margin to match
			   let countTo = 0;
               if (window.innerWidth < 850) {
                  countTo = numberCols[c].getAttribute('data-value')*34;
               } else {
                  countTo = numberCols[c].getAttribute('data-value')*50;
               }

               delay = i*delayMilliseconds;
               setTimeout(function() {
                  numberCols[c].children[0].style.marginTop = "-"+countTo+"px";
               }, delay);

            }
        }
	}
}
